import { EventBus } from "@/assets/event-bus";
import Vue from "vue";
import Router from "vue-router";
import { i18n } from "@/i18n";
import AppFooter from "./layout/AppFooter";
import AppHeader from "./layout/AppHeader";
Vue.use(Router);

//使用钩子函数对路由进行权限跳转

const router = new Router({
	linkExactActiveClass: "active",
	mode: "history",
	base: "/",
	routes: [
		{
			path: "/",
			name: "home",
			components: {
				header: AppHeader,
				default: () => import("./views/Home"),
				footer: AppFooter,
			},
meta: {
				title: "wire China 2026 第12届 | 上海线缆线材全产业链盛会",
				keywords: "中国国际线缆及线材展览会,wire China,上海线缆展,电线电缆展览会,线束展,连接器展,线缆设备展,线缆材料展,2026线缆展,上海新国际博览中心,观众预登记,线缆高峰论坛",
				description: "中国国际线缆及线材展览会（wire China）第12届，2026年9月21-24日亮相上海新国际博览中心。亚洲领先线缆·线材·线束·连接器全产业链盛会，汇聚全球展商与专业买家，同期举办高峰论坛与技术峰会。即刻预订展位或预登记免费观众证！"
			}
		},
		{
			path: "/about",
			name: "about",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanhuigailan/Overview"),
				footer: AppFooter,
			},
meta: {
				title: "关于wire China | 中国国际线缆及线材展览会介绍",
				keywords: "关于wire China，wire China展会介绍，第十二届线缆展，亚洲线缆展会，国际线缆展，杜塞尔多夫展览，上海电缆研究所，线缆展历史，wire China主办方",
				description: "关于wire China：中国国际线缆及线材展览会是亚洲乃至世界范围内最具影响力的线缆线材行业盛会之一，由上海电缆研究所有限公司与杜塞尔多夫展览(上海)有限公司共同主办，致力于向业界呈现最新的产品、技术及解决方案。"
			}
		},
		{
			path: "/media",
			name: "media",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanhuigailan/media"),
				footer: AppFooter,
			},
meta: {
				title: "合作媒体 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China合作媒体，线缆行业媒体伙伴，电缆行业媒体，线缆展会报道媒体，电线电缆媒体，线缆行业新闻合作，wire China媒体合作",
				description: "wire China 2026 合作媒体专区 — 汇集与 wire China 中国国际线缆及线材展览会建立官方合作的行业媒体及大众媒体机构，搭建行业资讯传播与企业品牌曝光的桥梁。"
			}
		},
		{
			path: "/dynamic",
			name: "dynamic",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanhuigailan/Dynamic"),
				footer: AppFooter,
			},
meta: {
				title: "展会动态 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China展会动态，线缆行业资讯，电线电缆行业新闻，线缆展会新闻，参展商动态，展会新闻报道，行业动态分析，cable exhibition news",
				description: "wire China 2026 展会动态页面，集中发布第12届中国国际线缆及线材展览会的官方新闻、展商动态、行业资讯及技术趋势分析，是了解本届展会进展的第一入口。"
			}
		},
		{
			path: "/transport",
			name: "transport",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanhuigailan/Transportation"),
				footer: AppFooter,
			},
meta: {
				title: "交通及住宿 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "上海新国际博览中心交通，龙阳路地铁站，上海浦东机场，虹桥火车站，线缆展住宿推荐，wire China交通指南，展会酒店，浦东住宿",
				description: "wire China 2026 交通及住宿指南 — 提供上海新国际博览中心（浦东龙阳路2345号）的地铁、公交、自驾路线，以及展会期间推荐的酒店住宿信息，方便参展商与观众顺利出行。"
			}
		},
		{
			path: "/zsLogin",
			name: "zsLogin",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/login/ZsLogin"),
				footer: AppFooter,
			},
meta: {
				title: "展商登录 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China展商登录，参展商登录入口，展商账号登录，展商密码登录，展位管理登录，展商后台登录，线缆展展商入口",
				description: "wire China 2026 展商登录入口 — 已注册的展商可凭账号、密码或验证码登录展商中心，管理展位资料、宣传物料、参展证件及参展流程。"
			}
		},
		{
			path: "/zsCenter",
			name: "zsCenter",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanshang/ZsCenter"),
				footer: AppFooter,
			},
meta: {
				title: "展商中心 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China展商中心，展商后台，展位管理，参展进度，展商服务，展商物料管理，展商证件申请，展位确认",
				description: "wire China 2026 展商中心 — 为参展商提供展位进度查看、宣传物料提报、展商证件申请、参展手册下载、邀请客户登记等全方位展商服务的统一入口。"
			}
		},

		{
			path: "/zwApply",
			name: "zwApply",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanshang/ZwApply"),
				footer: AppFooter,
			},
meta: {
				title: "展位申请 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China展位申请，2026线缆展展位预订，线缆展招展，展位报价，参展申请，wire China招展热线，电缆展展位预订",
				description: "wire China 2026 展位申请入口 — 第12届中国国际线缆及线材展览会的展位招展页面，支持参展商在线提交展位申请、查询展位图、了解展位报价及招展进度。"
			}
		},
		{
			path: "/czsList",
			name: "czsList",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanshang/CzsList"),
				footer: AppFooter,
			},
		},
		{
			path: "/czProcess",
			name: "czProcess",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanshang/CzProcess"),
				footer: AppFooter,
			},
meta: {
				title: "展商名单 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "2026电线电缆展，中国国际线缆及线材展览会，电缆展会信息，电线电缆展会，新国际博览中心，上海电缆研究所有限公司，电线电缆，参展商名录，wire China展商，线缆企业名录",
				description: "wire China 2026 展商名单 — 汇聚第12届中国国际线缆及线材展览会的所有参展企业信息，覆盖线材制造及精加工机械、辅助加工、原辅材料、成品线材及电线电缆、测控技术、检测工程等全产业链展商。"
			}
		},
		{
			path: "/zsPropagateApply",
			name: "zsPropagateApply",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanshang/ZsPropagateApply"),
				footer: AppFooter,
			},
meta: {
				title: "参展流程 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China参展流程，线缆展参展步骤，展位申请流程，参展商参展指南，招展流程，参展手册，wire China参展步骤",
				description: "wire China 2026 参展流程详解 — 从展位申请、合同签订、资料提交、人员注册到现场布展、撤展，完整呈现第12届中国国际线缆及线材展览会的参展全流程。"
			}
		},
		{
			path: "/vistor/materials",
			name: "vistorMaterials",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/Materials"),
				footer: AppFooter,
			},
		},
		{
			path: "/vistor/register",
			name: "vistorRegister",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/Register"),
				footer: AppFooter,
			},
meta: {
				title: "展商宣传申请 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China展商宣传，展会宣传位申请，展商品牌推广，展商广告位，现场物料投放，展商宣传服务，wire China增值服务",
				description: "wire China 2026 展商宣传申请入口 — 为参展商提供展期广告位、会议赞助、现场物料投放、品牌联合推广等增值宣传服务的在线申请通道。"
			}
		},
		{
			path: "/vistor/register-cgt",
			name: "vistorRegisterCgt",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/CgtSign"),
				footer: AppFooter,
			},
meta: {
				title: "观众资料下载 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China资料下载，展会会刊，展后报告，展商名单，展会预览，线缆展资料，cable exhibition materials，exhibitor list download，展会邀请函下载，参观指南下载",
				description: "wire China 2026 观众资料下载中心 — 提供展会邀请函、展馆分布图、参展商名单、电子会刊及展后报告等资料的免费下载入口。"
			}
		},
		{
			path: "/vistor/Cgt-Center",
			name: "vistorCgtCenter",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/CgtCenter"),
				footer: AppFooter,
			},
meta: {
				title: "观众注册 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China观众注册，2026线缆展观众预登记，免费参观证，线缆展观众报名，电线电缆观众预登记，参观证申请",
				description: "wire China 2026 观众注册 / 预登记入口 — 提前完成在线预登记，可获得免费参观证，免去现场排队登记流程，享受快速入场、展会资料免费领取等观众专属服务。"
			}
		},
		{
			path: "/vistor/team-apply",
			name: "vistorCgtteamapply",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/teamapply"),
				footer: AppFooter,
			},
		},
		{
			path: "/vistor/Cgt-Login",
			name: "vistorCgtLogin",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/login/CgtLogin"),
				footer: AppFooter,
			},
		},
		{
			path: "/vistor/register-gz",
			name: "vistorRegisterGz",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/GzSign"),
				footer: AppFooter,
			},
meta: {
				title: "参观团注册 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China参观团，团体观众注册，参观团申请，组团观展，VIP观众礼遇，团体参观，cable exhibition group visit",
				description: "wire China 2026 参观团注册入口 — 5人及以上即可成团登记参观，享受 VIP 观众礼遇：免费会刊、专属通道、团组合影、大巴临时下客证等团队专属服务。"
			}
		},
		{
			path: "/meet/industry-conference",
			name: "meetIndustryConference",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/meet/IndustryConference"),
				footer: AppFooter,
			},
meta: {
				title: "参观团中心 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China参观团中心，团队管理，团员信息，团组资料下载，参观团权益，团体观众后台，参观团状态查询",
				description: "wire China 2026 参观团中心 — 团组负责人可登录管理本团成员信息、查看团组审核进度、下载团体观众专属资料，并享受参观团 VIP 权益。"
			}
		},
		{
			path: "/meet/technical-exchange",
			name: "meetTechnicalExchange",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/meet/TechnicalExchange"),
				footer: AppFooter,
			},
meta: {
				title: "参观团申请 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "参观团注册，参观团申请，团体观众，VIP观众礼遇，组团观展，线缆展团体，cable exhibition group visit，team registration，组团参观，线缆行业组团",
				description: "wire China 2026 参观团申请入口 — 5人及以上即可成团，享受VIP观众礼遇，包括快速领取参观证、免费会刊、团组合影及大巴临时下客证等专属服务。"
			}
		},
		{
			path: "/meet/overseas-exhibition",
			name: "meetOverseasExhibition",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/meet/OverseasExhibition"),
				footer: AppFooter,
			},
meta: {
				title: "参观团登录 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "参观团登录，团体观众登录，团组账号，cable exhibition group login，team visitor login，线缆展观众团",
				description: "wire China 2026 参观团登录入口 — 团体观众可通过账号密码登录参观团中心，管理团员信息及团体权益。"
			}
		},
		{
			path: "/meet/cable-cloud",
			name: "meetCableCloud",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/meet/CableCloud"),
				footer: AppFooter,
			},
meta: {
				title: "观众注册（广州） | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China广州观众注册，广州线缆展观众预登记，广州电线电缆展参观证，粤港澳大湾区线缆展，南方线缆行业观众报名",
				description: "wire China 2026 广州观众注册 — 方便粤港澳大湾区及华南地区线缆行业观众就近完成预登记，凭预登记凭证在上海新国际博览中心现场或华南授权换证点领取参观证。"
			}
		},
		{
			path: "/meet/other",
			name: "meetOther",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/meet/Other"),
				footer: AppFooter,
			},
		},
		{
			path: "/product/supplier",
			name: "productSupplier",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/Supplier"),
				footer: AppFooter,
			},
meta: {
				title: "行业大会 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China行业大会，中国电线电缆行业大会，电缆行业协会大会，中国电器工业协会电线电缆分会，线缆行业高峰论坛",
				description: "wire China 2026 行业大会 — 第12届中国国际线缆及线材展览会同期举办的中国电线电缆行业大会系列活动，由中国电器工业协会电线电缆分会与上海电缆研究所有限公司共同举办。"
			}
		},
		{
			path: "/product/supplier-detail",
			name: "productSupplierDetail",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/SupplierDetail"),
				footer: AppFooter,
			},
meta: {
				title: "技术交流会 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China技术交流会，线缆技术论坛，电缆技术研讨，高压电缆绝缘，绿色低碳线缆，新能源线缆技术，5G通信海缆，线缆技术创新",
				description: "wire China 2026 技术交流会 — 紧扣高压电缆、绿色低碳、智能装备、新能源线缆、5G 通信海缆等当前热点趋势，邀请线缆行业知名企业与资深专家同台开讲，搭建新产品、新技术的交流平台。"
			}
		},
		{
			path: "/product/product-detail",
			name: "productProduceDetail",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/ProductDetail"),
				footer: AppFooter,
			},
meta: {
				title: "海外展览 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "海外线缆展，国际电缆展，菲律宾线缆展，德国线缆展，越南线缆展，印尼线缆展，wire Düsseldorf，线缆企业出海",
				description: "wire China 2026 海外展览版块 — 整合主办方旗下重要国际线缆展会信息（包括 wire Düsseldorf 等），助力中国线缆企业了解全球行业展会，开拓海外市场。"
			}
		},
		{
			path: "/product/asktobuy",
			name: "productAskToBuy",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/AskToBuy"),
				footer: AppFooter,
			},
meta: {
				title: "线缆云会 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "线缆云会WICE，上海电缆研究所，特种电缆技术国家重点实验室，中国电器工业协会电线电缆分会，线缆技术线上交流",
				description: "wire China 2026 线缆云会（WICE）— 由特种电缆技术国家重点实验室、中国电器工业协会电线电缆分会与上海电缆研究所有限公司共同主办，提供线缆行业线上技术分享与传播。"
			}
		},
		{
			path: "/product/home",
			name: "productHome",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/Home"),
				footer: AppFooter,
			},
meta: {
				title: "其他会议及活动 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China同期活动，主题论坛，线缆行业沙龙，颁奖典礼，主题参观路线，cable industry events，wire China activities，行业交流活动，主题展览",
				description: "wire China 2026 同期举办的其他会议及活动 — 包括主题论坛、行业沙龙、颁奖典礼、主题参观路线参观等多元化活动，为参展商与观众提供更丰富的现场交流机会。"
			}
		},
		{
			path: "/product/Recommended",
			name: "ProRecList",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/Recommended"),
				footer: AppFooter,
			},
meta: {
				title: "特色产品展示（展商） | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China特色产品，展商展品，线缆展展商列表，线缆设备厂家，电线电缆生产设备，电线电缆成品，特种电缆",
				description: "wire China 2026 特色产品展示（展商视角） — 面向采购商的展商展品总览，覆盖线材制造与精加工机械、辅助加工、原辅材料、成品线材及电线电缆、测控与检测工程等全产业链展商与产品。"
			}
		},
		{
			path: "/product/ExhibitorRecommendation",
			name: "ExhibitorRecommendation",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/ExhibitorRecommendation"),
				footer: AppFooter,
			},
meta: {
				title: "展商产品详情 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "展商展品详情，电线电缆产品详情，线缆展展品页，线缆产品参数，线缆产品应用，展商产品介绍",
				description: "wire China 2026 展商产品详情页 — 展示具体展商所提供产品的型号、参数、应用场景与联系方式，便于采购方深入了解展品并建立联系。"
			}
		},
		{
			path: "/product/PopularVideos",
			name: "PopularVideos",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/PopularVideos"),
				footer: AppFooter,
			},
meta: {
				title: "生产设备详情 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "线缆生产设备详情，拉丝机设备，绞线机设备，成缆机，电缆挤出机，线缆设备技术参数，线缆设备厂商",
				description: "wire China 2026 生产设备详情页 — 详细介绍拉丝机、绞线机、成缆机、挤出机等线缆生产设备的型号、性能、技术参数及对应厂商信息。"
			}
		},
		{
			path: "/product/release",
			name: "productRelease",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/product/Release"),
				footer: AppFooter,
			},
meta: {
				title: "发布求购信息 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "线缆求购信息，采购电线电缆，电线电缆求购，线缆采购需求，线缆产品询价，wire China求购发布",
				description: "wire China 2026 求购信息发布页 — 采购方可在线发布电线电缆、设备及原辅材料的求购需求，由系统与展商库智能匹配并推送至相关展商，提高对接效率。"
			}
		},
		{
			path: "/vistor/center",
			name: "vistorCenter",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/VistorCenter"),
				footer: AppFooter,
			},
			meta: {
				title: "观众中心 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China观众中心，观众后台，参观证管理，观众预约，收藏展商，观众资料下载",
				description: "wire China 2026 观众中心 — 已预登记的观众可登录账号，管理参观证、预约感兴趣的展商、收藏展品，并下载展会相关资料。"
			},
meta: {
				title: "特色产品展示（采购） | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China特色产品采购，采购专区，电线电缆采购，线缆设备采购，原辅材料采购，线缆采购平台",
				description: "wire China 2026 特色产品采购专区 — 面向采购商的产品总览，按线材制造及精加工机械、辅助加工、原辅材料、特种电线电缆、测控与检测工程等品类聚合展示。"
			}
		},
		{
			path: "/vistor/login",
			name: "vistorLogin",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/login/VistorLogin"),
				footer: AppFooter,
			},
			meta: {
				title: "观众登录 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China观众登录，参观证账号登录，观众后台登录，观众预登记账号",
				description: "wire China 2026 观众登录入口 — 已预登记的观众可通过手机号、邮箱或参观证编号登录观众中心，查看预约与个性化内容。"
			},
meta: {
				title: "推荐产品 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "推荐产品，电线电缆推荐，线缆展热门展品，主推产品，展商精选产品，新品推荐",
				description: "wire China 2026 推荐产品页 — 精选本届展会中受到采购方关注、行业内领先的展商品牌与新产品，集中推荐高质量、特色化线缆产品。"
			}
		},
		{
			path: "/visa-apply",
			name: "visaApply",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/VisaApply"),
				footer: AppFooter,
			},
			meta: {
				title: "签证申请 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "中国签证申请，线缆展签证邀请函，wire China邀请函，外国观众签证，展会签证，赴华签证，签证申请指南",
				description: "wire China 2026 签证申请服务 — 面向需要赴华参观的国际观众，提供签证邀请函申请、签证办理指南及常见问答，便于跨境观众顺利取得签证。"
			},
meta: {
				title: "推荐展商 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "推荐展商，电线电缆优选展商，wire China优质参展商，知名线缆企业，线缆品牌展商，cable industry leading exhibitors",
				description: "wire China 2026 推荐展商页 — 面向采购方与专业观众，精选行业领先的线缆品牌、知名生产企业和重点参展商，便于快速触达优质合作对象。"
			}
		},
		{
			path: "/vistor/factory",
			name: "factory",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/vistor/factory"),
				footer: AppFooter,
			},
			meta: {
				title: "工厂开放日 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China工厂开放日，走进工厂，工厂参观，线缆工厂，电缆制造工厂，工厂深度探访，线缆制造工艺，cable factory tour，wire China Factory Day，工厂沉浸式参观",
				description: "wire China 2026 工厂开放日活动 — 带领行业同仁走进桑浦电缆机械及易藤电气等优质线缆制造企业，实地考察生产一线、技术工艺及综合实力，建立深度信任与合作。"
			},
		},
		{
			path: "/dynamic-detail",
			name: "dynamicDetail",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/zhanhuigailan/DynamicDetail"),
				footer: AppFooter,
			},
			meta: {
				title: "展会动态详情 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China新闻，线缆行业资讯，展会动态详情，线缆行业新闻，电线电缆行业资讯，cable industry news，行业新闻报道",
				description: "wire China 2026 展会动态详情页 — 分享展会新闻、参展商动态、线缆行业资讯及技术趋势分析，提供线缆行业权威信息。"
			},
		},
		{
			path: "/search",
			name: "search",
			components: {
				header: AppHeader,
				default: () => import("./views/Search"),
				footer: AppFooter,
			},
			meta: {
				title: "搜索 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China搜索，线缆展展商搜索，展品搜索，求购信息搜索，展会动态搜索，cable exhibition search，线缆产品搜索",
				description: "wire China 2026 搜索中心 — 提供展商、展品、求购信息、展会动态、展会资料等多类型内容的统一搜索功能。"
			},
		},
		{
			path: "/share",
			name: "share",
			components: {
				header: AppHeader,
				default: () => import("./views/share-template.vue"),
				footer: AppFooter,
			},
			meta: {
				title: "分享推广 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China分享推广，展会邀请函分享，线缆展社交分享，参展邀请海报，promotional code 分享",
				description: "wire China 2026 分享推广页 — 展商与观众可生成专属邀请链接、二维码或海报，邀请同行共同参观，统计邀请效果，赢取额外礼遇。"
			},
meta: {
				title: "热门视频 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China热门视频，展商视频，线缆产品视频，展会精彩回顾，线缆工艺视频，展会直播回放",
				description: "wire China 2026 热门视频专区 — 聚合展商宣传片、产品演示视频、展会精彩回顾与直播回放内容，多角度呈现线缆行业最新技术与现场盛况。"
			}
		},
		{
			path: "/video-preview",
			name: "videoPreview",
			components: {
				// header: AppHeader,
				default: () => import("./views/pc/meet/VideoPreview"),
				// footer: AppFooter,
			},
			meta: {
				title: "视频预览 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China视频预告，展会宣传片，线缆展直播预告，wire China视频集锦，cable exhibition video，展会VCR，展商视频",
				description: "wire China 2026 视频预览页面 — 集中呈现展会官方宣传片、展商集锦、直播预告及历年展会精彩回顾视频内容。"
			},
		},
		{
			path: "/resource-center",
			name: "resourceCenter",
			components: {
				header: AppHeader,
				default: () => import("./views/pc/ResourceCenter"),
				footer: AppFooter,
			},
			meta: {
				title: "资源中心 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China资源中心，展商手册下载，观众手册下载，展会会刊，展后报告，会刊下载，展会资料",
				description: "wire China 2026 资源中心 — 提供展会邀请函、展馆分布图、参展商手册、观众参观指南、电子会刊及展后报告等官方资料的统一下载入口。"
			},
meta: {
				title: "发布产品 | wire China 2026 第12届中国国际线缆及线材展览会",
				keywords: "wire China发布产品，展商发布新品，线缆新产品发布，wire China新品上架，展商产品上传",
				description: "wire China 2026 发布产品入口 — 展商可在线提交新产品或新技术资料，经审核后展示在展会新产品专区，提升新品曝光与对接效率。"
			}
		}
	],
	scrollBehavior: (to) => {
		if (to.hash) {
			return { selector: to.hash };
		} else {
			return { x: 0, y: 0 };
		}
	},
});

router.beforeEach((to, from, next) => {
	EventBus.$emit("handleAppShowMore", false);
	
  const updateMetadata = (name, content, isProperty = false) => {
    const tag = document.querySelector(isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`) ||
                document.createElement('meta');
    if (!tag.parentElement) {
      isProperty ? tag.setAttribute('property', name) : tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.content = content || '';
  };
  
  // 根据当前语言获取对应meta信息
  const currentLang = i18n.locale;
  const routeName = to.name;
  
  // 从i18n中获取meta信息
  let meta = {};
  if (i18n.messages[currentLang] && i18n.messages[currentLang].h && i18n.messages[currentLang].h.meta && i18n.messages[currentLang].h.meta[routeName]) {
    meta = i18n.messages[currentLang].h.meta[routeName];
  }
  
  // 设置三要素
  document.title = meta.title || to.meta.title || '中国国际线缆及线材展览会';
  updateMetadata('description', meta.description || to.meta.description);
  updateMetadata('keywords', meta.keywords || to.meta.keywords);
  // 同步社交分享卡片（og 标签，随语言切换）
  if (meta.ogTitle) updateMetadata('og:title', meta.ogTitle, true);
  if (meta.ogDescription) updateMetadata('og:description', meta.ogDescription, true);
  if (meta.ogType) updateMetadata('og:type', meta.ogType, true);
  if (meta.ogSiteName) updateMetadata('og:site_name', meta.ogSiteName, true);
  // og:url 未单独配置时回退到 canonical / 当前地址，保证分享卡片指向正确页面
  const canonical = document.querySelector('link[rel="canonical"]');
  updateMetadata('og:url', meta.ogUrl || (canonical && canonical.href) || window.location.href, true);
	next();
});
export default router;
